import React from "react";
import { useContext } from "react";
import { UIContext } from "../hooks/useProviderContext/useProviderContext";

const BusinessIdRequired = () => (
  <div className="min-h-screen overflow-y-auto flex flex-col items-center justify-center bg-gray-50 p-3">
    <h2 className="text-2xl font-semibold text-gray-800 mb-4">
      Business ID Required
    </h2>
    <p className="text-gray-600 mb-6">
      Please wrap your application with UIProvider and provide a valid business
      ID.
    </p>
    <div className="bg-gray-100 p-4 rounded-md">
      <code className="BookEZ_font_body_size  text-gray-700">
        {`<UIProvider businessId="your-business-id" BookezToken="your-business-token">`}
        <br />
        &nbsp;&nbsp;{`<YourApp />`}
        <br />
        {`</UIProvider>`}
      </code>
    </div>
  </div>
);

export function withUIProtection<P extends object>(
  WrappedComponent: React.ComponentType<P>
) {
  return function ProtectedComponent(props: P) {
    const context = useContext(UIContext);

    if (!context || !context.businessId) {
      return <BusinessIdRequired />;
    }

    return <WrappedComponent {...props} />;
  };
}
